/**
 * Centralized utility for form control naming
 * Handles both 0-based (form control indices) and 1-based (question numbers) indexing
 */
export class FormNamingUtil {
  /**
   * Get question form control name
   * @param index - Can be 0-based form control index or 1-based question number
   * @returns Form control name like "question_0" or "question_1"
   */
  static getQuestionName(index: number): string {
    return `question_${index}`;
  }

  /**
   * Get additional info form control name
   * @param index - Can be 0-based form control index or 1-based question number
   * @returns Form control name like "question_0_additionalInfo" or "question_1_additionalInfo"
   */
  static getAdditionalInfoName(index: number): string {
    return `question_${index}_additionalInfo`;
  }

  /**
   * Get checkbox form control name
   * @param questionIndex - Can be 0-based form control index or 1-based question number
   * @param choiceIndex - Can be 0-based choice index or 1-based choice number
   * @returns Form control name like "question_0_0" or "question_1_1"
   */
  static getCheckboxName(questionIndex: number, choiceIndex: number): string {
    return `question_${questionIndex}_${choiceIndex}`;
  }
}
